var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-equipment"},[_c('div',{staticClass:"row special-equipment__list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"col-default-4 col-tablet-6 col-mobile-12 special-equipment__col"},[_c('equipment-card',{staticClass:"special-equipment__item",attrs:{"data":item}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }